import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  isPrinting = false;

  constructor(private router: Router) {}

  printDocument(
    documentName: string,
    documentData?: string[],
    documentData2?: string[]
  ) {
    this.isPrinting = true;
    if (documentData) {
      this.router.navigate([
        '/',
        {
          outlets: {
            print: [
              'print',
              documentName,
              documentData?.join(),
              documentData2?.join(),
            ],
          },
        },
      ]);
    } else {
      this.router.navigate([
        '/',
        {
          outlets: {
            print: ['print', documentName],
          },
        },
      ]);
    }
  }

  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
      const baseUrl = window.location.href.split('(')[0];

      window.location.href = baseUrl;
    });
  }
}
